module.exports = __webpack_public_path__ + "img/MaxCout.71ab303c.png";